/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_New_Password_CrumbInputs */

const en_auth_new_password_crumb = /** @type {(inputs: Auth_New_Password_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Password`)
};

/**
* | output |
* | --- |
* | "New Password" |
*
* @param {Auth_New_Password_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_new_password_crumb = /** @type {((inputs?: Auth_New_Password_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_New_Password_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_new_password_crumb(inputs)
});